var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page noselect" },
    [
      _c("v-container", { attrs: { "grid-list-md": "" } }, [
        _c("div", { staticClass: "text-center mt-7" }, [
          _c("h4", [_vm._v("DEBUG PARAMS")]),
          _c("div", { staticClass: "spacer-15" }),
          _c("div", [_vm._v(" PROD_ENV: " + _vm._s(_vm.PROD_ENV) + " ")]),
          _c("div", [_vm._v(" isDev: " + _vm._s(_vm.isDev) + " ")]),
          _c("div", [_vm._v(" table: " + _vm._s(_vm.table) + " ")]),
          _c("div", [
            _vm._v(
              " availableOrderModes: " +
                _vm._s(JSON.stringify(_vm.$store.getters.availableOrderModes)) +
                " "
            ),
          ]),
          _c("div", [
            _vm._v(
              "selectedOrderModeByUser: " +
                _vm._s(_vm.$store.getters.selectedOrderModeByUser)
            ),
          ]),
          _c("div", { staticClass: "spacer-15" }),
          _c("div", [
            _vm._v(
              " Auflösung: " +
                _vm._s(_vm.innerWidth) +
                "x" +
                _vm._s(_vm.innerHeight)
            ),
            _c("br"),
            _vm._v(" devicePixelRatio: " + _vm._s(_vm.devicePixelRatio)),
            _c("br"),
          ]),
          _c("div", [
            _vm._v(" storagePersist: " + _vm._s(_vm.storagePersist) + " "),
          ]),
          _c("div", [
            _vm._v(" swActive: " + _vm._s(_vm.$store.getters.swActive) + " "),
          ]),
          _c("div", [_vm._v(" withPosApi: " + _vm._s(_vm.withPosApi) + " ")]),
          _c("div", [
            _vm._v(" isKiosk: " + _vm._s(_vm.$store.getters.isKiosk) + " "),
          ]),
          _c("div", [
            _vm._v(
              " showKioskSplashOnHome: " +
                _vm._s(_vm.$store.getters.showKioskSplashOnHome) +
                " "
            ),
          ]),
          _c("div", [
            _vm._v(
              " enableKioskInhouseMitPay: " +
                _vm._s(_vm.enableKioskInhouseMitPay) +
                " "
            ),
          ]),
          _c("div", [
            _vm._v(
              " enableKioskInhousePayMitTip: " +
                _vm._s(_vm.enableKioskInhousePayMitTip) +
                " "
            ),
          ]),
          _c("div", [
            _vm._v(
              " enableKioskInhouseOhnePay: " +
                _vm._s(_vm.enableKioskInhouseOhnePay) +
                " "
            ),
          ]),
          _c("div", [
            _vm._v(
              " enableKioskTakeAwayMitPay: " +
                _vm._s(_vm.enableKioskTakeAwayMitPay) +
                " "
            ),
          ]),
          _c("div", [
            _vm._v(
              " enableKioskTakeAwayOhnePay: " +
                _vm._s(_vm.enableKioskTakeAwayOhnePay) +
                " "
            ),
          ]),
          _c("div", [_vm._v(" isoe: " + _vm._s(_vm.isoe) + " ")]),
          _c("div", [_vm._v(" isIos: " + _vm._s(_vm.isIos) + " ")]),
          _c("div", [
            _vm._v(" loggedIn: " + _vm._s(_vm.$store.getters.loggedIn) + " "),
          ]),
          _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "pt-2 pb-2 d-inline-block text-left renderLineBreaks",
              },
              [
                _c("b", [_vm._v("Stempelkarte:")]),
                _vm._v(
                  " " +
                    _vm._s(
                      JSON.stringify(_vm.$store.getters.stempelkarte, null, 2)
                    ) +
                    " "
                ),
              ]
            ),
          ]),
          _c("div", [
            _vm._v(
              " selfServiceEnabled: " + _vm._s(_vm.selfServiceEnabled) + " "
            ),
          ]),
          _c("div", [
            _vm._v(
              " enableSelfServiceExtras: " +
                _vm._s(_vm.enableSelfServiceExtras) +
                " "
            ),
          ]),
          _c("div", [_vm._v(" isInhouse: " + _vm._s(_vm.isInhouse) + " ")]),
          _c("div", [
            _vm._v(" orderingEnabled: " + _vm._s(_vm.orderingEnabled) + " "),
          ]),
          _c("div", [_vm._v(" tipEnabled: " + _vm._s(_vm.tipEnabled) + " ")]),
          _c("div", [
            _vm._v(
              " takeawayOrderingEnabled: " +
                _vm._s(_vm.takeawayOrderingEnabled) +
                " "
            ),
          ]),
          _c("div", [
            _vm._v(
              " inhouseOrderingEnabled: " +
                _vm._s(_vm.inhouseOrderingEnabled) +
                " "
            ),
          ]),
          _c("div", [
            _vm._v(
              " deliveryOrderingEnabled: " +
                _vm._s(_vm.deliveryOrderingEnabled) +
                " "
            ),
          ]),
          _c("div", [
            _vm._v(" enableInhousePay: " + _vm._s(_vm.enableInhousePay) + " "),
          ]),
          _c("div", [
            _vm._v(
              " enableInhouseOhnePay: " + _vm._s(_vm.enableInhouseOhnePay) + " "
            ),
          ]),
          _c("div", [
            _vm._v(
              " enableTakeawayPay: " + _vm._s(_vm.enableTakeawayPay) + " "
            ),
          ]),
          _c("div", [
            _vm._v(
              " enableTakeawayOhnePay: " +
                _vm._s(_vm.enableTakeawayOhnePay) +
                " "
            ),
          ]),
          _c("div", [
            _vm._v(
              " enableDeliveryPay: " + _vm._s(_vm.enableDeliveryPay) + " "
            ),
          ]),
          _c("div", [
            _vm._v(
              " enableDeliveryOhnePay: " +
                _vm._s(_vm.enableDeliveryOhnePay) +
                " "
            ),
          ]),
          _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "pt-2 pb-2 d-inline-block text-left renderLineBreaks",
              },
              [
                _c("b", [_vm._v("Abholzeiten:")]),
                _vm._v(
                  " " +
                    _vm._s(
                      JSON.stringify(
                        _vm.$store.getters.appconfig.takeAway.openingHours,
                        null,
                        2
                      )
                    ) +
                    " "
                ),
              ]
            ),
          ]),
          _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "pt-2 pb-2 d-inline-block text-left renderLineBreaks",
              },
              [
                _c("b", [_vm._v("Lieferzeiten:")]),
                _vm._v(
                  " " +
                    _vm._s(
                      JSON.stringify(
                        _vm.$store.getters.appconfig.delivery.openingHours,
                        null,
                        2
                      )
                    ) +
                    " "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }